import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { store } from '@/redux/store';
import { router } from '@/routers/index.router';
import { ThemeProvider } from 'next-themes';
import { ToastContainer } from '@/components/ui/toast';
import { CopyNotificationContainer } from '@/components/ui/copy-notification-container';
import { ToastContainer as ToastifyContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
        <RouterProvider router={router} />
        <ToastContainer />
        <ToastifyContainer />
        <CopyNotificationContainer />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
